module.exports = __webpack_public_path__ + "static/media/3@2x.2f1fa614.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/3@2x.png
// module id = 362
// module chunks = 0